module.exports = __webpack_public_path__ + "static/media/noun-custom-729128-142350.b97016c8.svg";